import { Helmet } from "react-helmet-async";
import { Button } from "@ceskastranaasocialu/komponenty";
import logo from "../../images/home/logo-border.webp";
import "./Domov.css";

import RandomPic0 from "../../images/home/randompics/0.webp";
import RandomPic1 from "../../images/home/randompics/1.webp";
import RandomPic2 from "../../images/home/randompics/2.webp";
import RandomPic3 from "../../images/home/randompics/3.webp";
import RandomPic4 from "../../images/home/randompics/4.webp";
import RandomPic5 from "../../images/home/randompics/5.webp";
import RandomPic6 from "../../images/home/randompics/6.webp";
import RandomPic7 from "../../images/home/randompics/7.webp";
import RandomPic8 from "../../images/home/randompics/8.webp";
import RandomPic9 from "../../images/home/randompics/9.webp";
import RandomPic10 from "../../images/home/randompics/10.webp";
import RandomPic11 from "../../images/home/randompics/11.webp";
import RandomPic12 from "../../images/home/randompics/12.webp";
import RandomPic13 from "../../images/home/randompics/13.webp";
import RandomPic14 from "../../images/home/randompics/14.webp";
import RandomPic15 from "../../images/home/randompics/15.webp";
import RandomPic16 from "../../images/home/randompics/16.webp";
import RandomPic17 from "../../images/home/randompics/17.webp";
import RandomPic18 from "../../images/home/randompics/18.webp";
import RandomPic19 from "../../images/home/randompics/19.webp";
import RandomPic20 from "../../images/home/randompics/20.webp";
import RandomPic21 from "../../images/home/randompics/21.webp";
import RandomPic22 from "../../images/home/randompics/22.webp";
import RandomPic23 from "../../images/home/randompics/23.webp";
import RandomPic24 from "../../images/home/randompics/24.webp";
import RandomPic25 from "../../images/home/randompics/25.webp";
import RandomPic26 from "../../images/home/randompics/26.webp";
import RandomPic27 from "../../images/home/randompics/27.webp";
import RandomPic28 from "../../images/home/randompics/28.webp";
import RandomPic29 from "../../images/home/randompics/29.webp";
import Vozík from "../../images/home/Vozík2.webp";
import Agenti from "../../images/home/Agenti2.webp";
import mainTitle from "../../images/Titles/web_ostrane_nadpis.webp";

const randomPics = [RandomPic0, RandomPic1, RandomPic2, RandomPic3, RandomPic4, RandomPic5, RandomPic6, RandomPic7, RandomPic8, RandomPic9, RandomPic10, RandomPic11, RandomPic12, RandomPic13, RandomPic14, RandomPic15, RandomPic16, RandomPic17, RandomPic18, RandomPic19, RandomPic20, RandomPic21, RandomPic22, RandomPic23, RandomPic24, RandomPic25, RandomPic26, RandomPic27, RandomPic28, RandomPic29];

const stanovyOdkazy = [
    { className: "časnovýroman", href: "/assets/CSA_Stanovy_Times-New-Roman.pdf", label: "Stanovy v Times New Roman" },
    { className: "komickýsans", href: "/assets/CSA_Stanovy_Comic-Sans.pdf", label: "Stanovy v Comic Sans" },
    { className: "třetífont", href: "/assets/CSA_Stanovy_Nediakritice.pdf", label: "Stanovy co neumí diakritiku" }
];

export default function Domov() {
    let usedImageIndexes = [];
    let randomPicsArray = [];
    for (let i = 0; i < 2; i++) {
        let randomIndex = Math.floor(Math.random() * randomPics.length);
        while (usedImageIndexes.includes(randomIndex)) {
            randomIndex = Math.floor(Math.random() * randomPics.length);
        }
        usedImageIndexes.push(randomIndex);
        randomPicsArray.push(randomPics[randomIndex]);
    }
    return (
        <>
            <Helmet>
                <title>Česká Strana Asociálů</title>
                <meta name="description" content="ČSA je recesistická politická strana, jejíž cílem, pokud ti to ještě nedošlo, je naprostá asocializace společnosti a České republiky. Chození ven způsobilo války, neštěstí a zmar, proto tu jsou asociálové, aby vše napravili. HLAVNĚ TO PROBOHA NEBERTE VÁŽNĚ, JSME RECESISTI!" />
                <meta property="og:title" content="Česká Strana Asociálů" />
                <meta property="og:description" content="ČSA je recesistická politická strana, jejíž cílem, pokud ti to ještě nedošlo, je naprostá asocializace společnosti a České republiky. Chození ven způsobilo války, neštěstí a zmar, proto tu jsou asociálové, aby vše napravili. HLAVNĚ TO PROBOHA NEBERTE VÁŽNĚ, JSME RECESISTI!" />
                <meta property="og:image" content={`${process.env.PUBLIC_URL}/assets/banner.png`} />
                <meta property="og:url" content="https://www.asocialove.cz/#/path" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Česká Strana Asociálů" />
                <meta name="twitter:description" content="ČSA je recesistická politická strana, jejíž cílem, pokud ti to ještě nedošlo, je naprostá asocializace společnosti a České republiky. Chození ven způsobilo války, neštěstí a zmar, proto tu jsou asociálové, aby vše napravili. HLAVNĚ TO PROBOHA NEBERTE VÁŽNĚ, JSME RECESISTI!" />
                <meta name="twitter:image" content={`${process.env.PUBLIC_URL}/assets/banner.png`} />
            </Helmet>
            <div className="mainTitle">
                <img src={mainTitle} draggable="false" alt=""></img>
            </div>
            <div id="mainContent">
                <div id="mainACTUALContent">
                    <div className="mainACTUALContentContainer">
                        <div className="mainACTUALContentTextContainer ma_border">
                            <p>Česká strana asociálů je skutečná strana, která vše rozhodně bere vážně fr fr. Hlavní aktivita je na discordu, protože chodit ven je SOCIALIZACE. Je chronicky aktivní, můžete tam najít zastání každého politického smýšlení. Taky má sociální sítě, instagram a twitter, kde nás sledují skuteční lidé včetně politiků se smyslem pro humor. Stranu aktivně podporuje Židovsko-zednářské spiknutí, Ilumináti, Hamás, Izrael, tajný BDSM klubík pana Zeleného a taky vláda Kepleru-22b.</p>
                        </div>
                        <div>
                            <img src={logo} alt="Logo ČSA" className="logocsa" draggable="false" />
                        </div>
                    </div>

                    <div className="dejinyStranyBlok">
                        <div className="nadpisHistorie">
                            <p>Rozhodně skutečné dějiny strany</p>
                        </div>
                        <div className="mainACTUALContentContainer">
                            <div className="mainACTUALContentImageContainer">
                                <img src={Vozík} draggable="false" alt="" />
                            </div>
                            <div className="mainACTUALContentTextContainer">
                                <p>
                                    Všechno začalo roku -5 před naším letopočtem, kdy svět byl ještě v pořádku. Nikdo nechodil ven, svět byl bez válek... Ale poté vstal Ježíš Kristus a nutil lidi se mít rádi. To se nelíbilo mnoha lidem, a tak vzniká Odboj proti socializaci (tzv. <i>Antikristi</i>), tímto též vzniká první předchůdce ČSA, což z nás dělá nejstarší stranu.
                                </p>
                            </div>
                        </div>
                        <div className="mainACTUALContentContainer">
                            <div className="mainACTUALContentTextContainer">
                                <p>
                                    Přesuneme se do 24. května 2022, kdy se třem lidem před očima zjevili předchozí antikristi a řekli: „Nyní je Váš úkol bojovat proti socializaci!"
                                    <br />
                                    Hned se udělaly účty na sociálních sítích na šíření asocialismu a po dvou měsících mínus deset dní i Discord.
                                </p>
                            </div>
                            <div className="mainACTUALContentImageContainer">
                                <img src={Agenti} draggable="false" alt="" />
                            </div>
                        </div>
                    </div>
                    <div className="stanovyBlok">
                        <div className="mainACTUALcontentStanovy">
                            <div className="hornitext">
                                <p>Jelikož nás stát nemá rád, jsme zákonem povinni na naše webovky dát stanovy. Nebylo ale nikým řečeno, jak musí vypadat, takže si můžete vybrat ze tří oku lahodících designů. </p>
                            </div>
                            <div className="stanovy">
                                {stanovyOdkazy.map(({ className, href, label }) => (
                                    <Button as="a" variant="dark" highlight download key={className} className={className} href={href}>
                                        {label}
                                    </Button>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
